import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShFormGroupComponent, ShFormMultiSelectModule } from '@stylehaven/components';
import { FormPermissionsComplexBaseComponent } from './base-complex/form-permissions-complex-base.component';
import { FormPermissionsBaseComponent } from './base-simple/form-permissions-base.component';
import { FormPermissionsComponent } from './main/form-permissions.component';

@NgModule({
    declarations: [FormPermissionsComponent, FormPermissionsBaseComponent, FormPermissionsComplexBaseComponent],
    imports: [CommonModule, ReactiveFormsModule, ShFormMultiSelectModule, ShFormGroupComponent],
    exports: [FormPermissionsComponent, FormPermissionsBaseComponent, FormPermissionsComplexBaseComponent]
})
export class FormPermissionsModule {}

export { FormPermissionsComplexBaseComponent } from './base-complex/form-permissions-complex-base.component';
export { FormPermissionsBaseComponent } from './base-simple/form-permissions-base.component';
export { FormPermissionsComponent } from './main/form-permissions.component';
